import { render, staticRenderFns } from "./DepositFunds.vue?vue&type=template&id=95420bba"
import script from "./DepositFunds.vue?vue&type=script&lang=js"
export * from "./DepositFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports